module.exports = __webpack_public_path__ + "img/icon_dark.956b02c2.png";